import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { getAllEnergeticCorrelations, EnergeticCorrelationResult } from '@/utils/energeticCorrelations';

export function useEnergeticCorrelations(days: number = 60) {
  const [correlations, setCorrelations] = useState<EnergeticCorrelationResult[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCorrelations = async () => {
      setIsLoading(true);
      setError(null);
      
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setError('Please sign in to view energetic correlations');
        setIsLoading(false);
        return;
      }

      try {
        const results = await getAllEnergeticCorrelations(user.id, days);
        setCorrelations(results);
      } catch (err) {
        console.error('Error fetching energetic correlations:', err);
        setError('Failed to load energetic correlations');
      }
      
      setIsLoading(false);
    };

    fetchCorrelations();
  }, [days]);

  return { correlations, isLoading, error };
}
